import { useSelector, useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import { getCaseLienHistory } from "../../../../../lib/fetchApi"
import { notificationActions } from "../../../../../store/notifications"
import LoadingSpinner from "../../../../common/LoadingSpinner"
import { formatDateLocalWithTime } from "../../../../../lib/script"

import classes from '../LienHistory.module.css'

export default function LienHistoryModal() {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [loading, setLoading] = useState(false)

    const [data, setData] = useState(null)

    useEffect(() => {
        async function fetchData() {
            if (activeCase) {
                setLoading(true)
                try {
                    const data = await getCaseLienHistory(userToken, activeCase.case.id)

                    if (data && data.errorMessage) {
                        dispatch(notificationActions.setError(data))
                    } else {
                        if (data?.data && data.data.length > 0) {
                            setData(data.data)
                        } else {
                            setData(null)
                        }
                    }
                } finally {
                    setLoading(false)
                }
            }
        }
        fetchData()
    }, [activeCase, dispatch, userToken])

 
    return <>
        {loading && <LoadingSpinner />}
        {!loading && <div>
            {data && data && data.length > 0 && data.map(item => (
                <div key={item.id} className={classes.item}>
                    <div className={classes.date} style={{ textAlign: 'center' }}>{formatDateLocalWithTime(item.created_at)}</div>
                    <div className={classes.text} dangerouslySetInnerHTML={{__html: item.message}} />
                </div>
            ))}
            {(!data || (data && data.length === 0)) && <p>No data found</p>}
        </div>}
    </>
}